// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"86e5f3f0","498":"4c9778c8","703":"eeb0a0f2","787":"a13203c3"}[chunkId] + ".chunk.js";
};